import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  useRouteMatch,
  useParams,
} from "react-router-dom";

import SideMenu from "./SideMenu";
// import UnitDetailMaster from "./storeDirectory/UnitDetailMaster";
import "bootstrap/dist/css/bootstrap.min.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUserCircle,
  faSignOutAlt,
  faFileAlt,
} from "@fortawesome/free-solid-svg-icons";

import GenerateTransaction from "./GenerateTransaction";
import InvoicePrint from "./InvoicePrint";
import InvoiceSend from "./InvoiceSend";
import ApproveTransaction from "./ApproveTransaction";
import ApplyTransaction from "./ApplyTransaction";
import DebitComponent from "./debit/DebitComponent";
import CreditComponent from "./credit/CreditComponent";
import GeneralComponent from "./receipt/General";
import ReceiptDeposit from "./receipt/Deposit";


import GeneralLedgerComponent from "./ledger/General";
import DepositLedgerComponent from "./ledger/Deposit";
import TopHeader from "../layout/TopHeader";

import { getUserRole } from "../utils/index";

export default function ViewLease() {
  let match = useRouteMatch();

  let reportArr = [
  ];

  return (
    <div>
      <TopHeader />
      <div className="masterContainer">
        <div className="masterClassMain mt-4">
          {(getUserRole() != "checker") && (
            <>
              <SideMenu reports_list={reportArr} />
              <Switch>

                <Route path={`${match.path}/general`}>
                  <GeneralComponent />
                </Route>

                <Route path={`${match.path}/deposit`}>
                  <ReceiptDeposit />
                </Route>

                <Route path={`${match.path}/generate`}>
                  <GenerateTransaction />
                </Route>


                <Route path={`${match.path}/debit`}>
                  <DebitComponent />
                </Route>

                <Route path={`${match.path}/credit`}>
                  <CreditComponent />
                </Route>


                <Route path={`${match.path}/ledger-general`}>
                  <GeneralLedgerComponent />
                </Route>

                <Route path={`${match.path}/ledger-deposit`}>
                  <DepositLedgerComponent />
                </Route>

                <Route path={`${match.path}/print`}>
                  <InvoicePrint />
                </Route>

                <Route path={`${match.path}/send`}>
                  <InvoiceSend />
                </Route>

                <Route path={`${match.path}`}>
                  {/* <div className="container">
                    <div className="row">
                      <div className="col-lg-12 mt20">
                        <h1 className="text-center">
                          <FontAwesomeIcon icon={faFileAlt} size="lg" />
                          <span>Transactions</span>
                        </h1>
                      </div>
                    </div>
                  </div> */}
                  <GenerateTransaction />
                </Route>


              </Switch>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
